import { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Layout, Drawer, Affix, Breadcrumb } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#2a1e39");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);

  const openDrawer = () => setVisible(!visible);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
  }, [pathname]);

  return (
    <>
      {fixed ? (
          <Affix>
            <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`} style={{ backgroundColor: "#a448ff",display: 'flex', alignItems: 'center' }}>
              <Header
                onPress={openDrawer}
                name={pathname}
                subName={''}
                handleSidenavColor={handleSidenavColor}
                handleSidenavType={handleSidenavType}
                handleFixedNavbar={handleFixedNavbar}
                style={{ display: 'flex', alignItems: 'center' }}
              />
            </AntHeader>
          </Affix>
        ) : (
          <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`} style={{ color: '#fff', backgroundColor: "#a448ff",display: 'flex', alignItems: 'center' }}>
            <Header
              onPress={openDrawer}
              name={pathname}
              subName={''}
              handleSidenavColor={handleSidenavColor}
              handleSidenavType={handleSidenavType}
              handleFixedNavbar={handleFixedNavbar}
            />
          </AntHeader>
        )}
      <Layout
        className={`layout-dashboard ${pathname === "profile" ? "layout-profile" : ""
          } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
      >
        <Drawer
          title={false}
          placement={placement === "right" ? "left" : "right"}
          closable={false}
          onClose={() => setVisible(false)}
          visible={visible}
          key={placement === "right" ? "left" : "right"}
          width={250}
          className={`drawer-sidebar ${pathname === "rtl" ? "drawer-sidebar-rtl" : ""
            } `}
        >
          <Layout
            className={`layout-dashboard ${pathname === "rtl" ? "layout-dashboard-rtl" : ""
              }`}
          >
            <Sider
              trigger={null}
              width={250}
              theme="light"
              className={`sider-primary ant-layout-sider-primary ${sidenavType === "#fff" ? "active-route" : ""
                }`}
              style={{ background: sidenavType }}
            >
              <Sidenav color={sidenavColor} />
            </Sider>
          </Layout>
        </Drawer>
        <Layout>
          <Content className="content-ant">
            <div style={{margin: '5px'}}>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <NavLink to="/">Home</NavLink>
                </Breadcrumb.Item>
                <Breadcrumb.Item >
                  {pathname.replace("/", " / ")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            {children}
          </Content>
        </Layout>
        <Footer />
      </Layout>
    </>
  );
}

export default Main;
